function n(n){return"version"in n}export{n as isVersionedTransaction};
